import { compose } from 'redux'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { getCurrentStore } from 'selectors'
import { showStoreLocatorModal } from 'actions/storeLocator'
import { isThirdPartyUrl, getEmailUrl, processExternalUrl } from '../helpers'
import BOTCareersContent from './BOTCareersContent'
import {
  PREDICTIVE_PROFILES,
  PREDICTIVE_PROFILES_DEFAULT_URL,
  REQUEST_AN_APPLICATION,
  STORE_EMAIL,
  SUBMIT_EMAIL_TITLE
} from '../constants'


const mapStateToProps = (state, {
  localStoreOpportunitiesMode,
  resourceUrl
}) => {
  const { storeNumber, storeId, owner: { email } = {}} = getCurrentStore(state) || {}
  const cleanedResourceUrl = localStoreOpportunitiesMode === PREDICTIVE_PROFILES && !resourceUrl ?
    PREDICTIVE_PROFILES_DEFAULT_URL : processExternalUrl(resourceUrl)

  return {
    storeNumber,
    hasSelectedStore: Boolean(getCurrentStore(state)),
    linkText: localStoreOpportunitiesMode === STORE_EMAIL || !cleanedResourceUrl ?
      REQUEST_AN_APPLICATION : SUBMIT_EMAIL_TITLE,
    resourceUrl: resourceUrl || email,
    storeEmail: email,
    hasResourceUrl: Boolean(resourceUrl),
    url: isThirdPartyUrl(localStoreOpportunitiesMode) && cleanedResourceUrl ?
      cleanedResourceUrl : getEmailUrl({ resourceUrl: cleanedResourceUrl || email, storeNumber, storeId })
  }
}

export default compose(
  withType({
    type: 'BOTCareersContent',
    placeholders: ['content']
  }),
  connect(mapStateToProps, { showStoreLocatorModal })
)(BOTCareersContent)
